export default __webpack_public_path__ + "463ffca245176382fbcc1daf96eb44dc.png";